<a class="value orms-link-button" [title]="value" routerLink="." (click)="displayChangeDetail()">
  {{ value }}
</a>
